import { makeStyles } from "@material-ui/core/styles";

const sequencerMixNewStyles = makeStyles((theme) => ({
  overviewRootStyle: {
    height: "calc(100vh - 110px)",
    overflow: "hidden",
    width: "100%",
    outline: "none",
    border: "none",
    boxShadow: "none",
    WebkitTapHighlightColor: "transparent",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  },

  viewBodyStyle: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  // sequencer player styles
  sequencerPlayerRoot: {
    backgroundColor: "#252A38",
    width: "100%",
    height: "100%",
    border: "1px solid red",
  },
  sequencerPlayerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    height: "53px",
    boxSizing: "border-box",
  },

  playerContainer: {
    position: "relative",
    width: "100%",
    height: "calc(100% - 50px)",
  },
  sequencerPlayerRootEmbedded: {
    backgroundColor: "#252a38",
    width: "100%",
    height: "100%",
    borderRadius: "10px 10px 0 0",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  playerContainerEmbedded: {
    position: "relative",
    width: "100%",
    flex: 1,
    minHeight: 0,
  },
  backButton: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
    [theme.breakpoints.down("xl")]: {
      fontSize: "14px !important",
    },
  },
  sequencerTitle: {
    fontWeight: "500",
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px !important",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "16px !important",
    },
    [theme.breakpoints.down("xl")]: {
      fontSize: "18px !important",
    },
  },
  shareAndExportButtons: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  shareButton: {
    border: "2px solid #6C65D9",
    [theme.breakpoints.down(1537)]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.up(1537)]: {
      fontSize: "12px !important",
    },
  },
  exportButton: {
    backgroundColor: "#6C65D9",
    color: "white",
    [theme.breakpoints.down(1537)]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.up(1537)]: {
      fontSize: "12px !important",
    },
  },
  sequencerVideoPlayerContainer: {
    height: "calc(100% - 80px)",
    position: "relative",
    backgroundColor: "black",
  },
  sequencerVideoControls: {
    padding: "8px",
    height: "max-content",
    boxSizing: "border-box",
    flexShrink: 0,
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  totalDuration: {
    color: theme.palette.text.tertiary,
  },
  // task template and shots styles
  taskAndShotsRoot: {
    backgroundColor: theme.palette.secondary.light,
    padding: "6px",
    height: "100%",
    overflowY: "auto",
    borderRadius: "10px",
    width: "100%",
  },
  taskAndShotsContainer: {
    backgroundColor: "#1B1D28",
    padding: "4px",
    height: "calc(100% - 100px)",
    boxSizing: "border-box",
    borderRadius: "10px",
    width: "100%",
  },
  lastSyncText: {
    marginTop: "10px",
    fontSize: "12px",
    color: theme.palette.text.tertiary,
  },
  syncAndCompareButtons: {
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    fontSize: "12px",
  },
  syncWithLatestButtons: {
    backgroundColor: theme.palette.primary.main,
    padding: "6px 10px",
    width: "100%",
    fontSize: "12px",
    [theme.breakpoints.down(1537)]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.up(1537)]: {
      fontSize: "12px !important",
    },
  },

  //task template styles
  singleTaskTemplate: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "4px 8px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  taskTemplateTitle: {
    [theme.breakpoints.down(1537)]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.up(1537)]: {
      fontSize: "12px !important",
    },
  },
  versionCount: {
    color: theme.palette.text.tertiary,
    [theme.breakpoints.down(1537)]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.up(1537)]: {
      fontSize: "12px !important",
    },
  },

  // sequences overview styles
  singleSequenceContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#252A38",
    borderRadius: "5px",
    width: "100%",
  },
  commentsContainer: {
    height: "300px",
    overflowY: "auto",
    boxSizing: "border-box",
    [theme.breakpoints.down("xl")]: {
      height: "45vh",
    },
    [theme.breakpoints.down("lg")]: {
      height: "300px",
    },
    [theme.breakpoints.down("md")]: {
      height: "300px",
    },
  },
  commentsContainerEmbedded: {
    height: "100%",
    overflowY: "auto",
    boxSizing: "border-box",
  },
  rightContainer: {
    height: "300px",
    width: "100%",
    overflowY: "auto",
    boxSizing: "border-box",
    [theme.breakpoints.down("xl")]: {
      height: "46vh",
    },
    [theme.breakpoints.down("lg")]: {
      height: "310px",
    },
    [theme.breakpoints.down("md")]: {
      height: "300px",
    },
    display: "flex",
    flexDirection: "column",
    marginTop: "10px",
  },
  button1: {
    backgroundColor: "#6C65D94D",
    color: "#F9F9F9",
    borderRadius: "5px",
    padding: "8px 16px",
    fontSize: "14px",
    width: "47%",
  },
  button1type2: {
    backgroundColor: "#6C65D94D",
    color: "#F9F9F9",
    borderRadius: "5px",
    padding: "8px 16px",
    fontSize: "14px",
  },
  button2: {
    backgroundColor: "#252A38",
    color: "#F9F9F9",
    borderRadius: "5px",
    padding: "8px 16px",
    fontSize: "14px",
    width: "47%",
  },
  //chats
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
  },
}));

export default sequencerMixNewStyles;
